import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { ProductItem } from '@/lib/types/api';
import { useQuery } from '@tanstack/react-query';
import { getProducts } from '@/lib/repository/products/products';
import { ProductListItem } from '../section/ProductsList';
import { useEffect, useState } from 'react';

export default function ProductSoldCTA({ product }: { product: ProductItem }) {
  const { t } = useTranslation('products');
  const { locale } = useRouter();
  const [machineTypeLink, setMachineTypeLink] = useState<string>('');
  const machineTypeId = [product.machine_types[0].id];

  const { data } = useQuery(['products'], () =>
    getProducts({
      page_size: 3,
      machine_type: machineTypeId,
      locale: locale ?? 'en-US',
    })
  );
  const products = data?.data?.products;
  useEffect(() => {
    if (!product?.machine_types?.length) return;

    const machineTypes = product.machine_types;

    if (machineTypes.length > 1) {
      const slugs = machineTypes.map((m) =>
        m.name.toLowerCase().replace(/\s/g, '-')
      );
      setMachineTypeLink(slugs.join('_'));
    } else {
      const slug = machineTypes[0].name.toLowerCase().replace(/\s/g, '-');
      setMachineTypeLink(slug);
    }
  }, [product.machine_types]);
  return (
    <div className='absolute left-1/2 top-1/2 z-20 flex w-full -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-4  bg-black bg-opacity-30 '>
      <div className='w-full select-none text-center font-extrabold uppercase tracking-widest drop-shadow-2xl'>
        <div className='mt-6 flex flex-col gap-2 px-6 text-center font-extralight  md:mt-0 md:gap-4'>
          <p className='text-sm text-white md:text-[2rem]'>
            {t('THANKS_FOR_YOUR_VISIT')}
          </p>
          <p className='text-sm text-white md:text-[1rem]'>
            {t('SOLD_PRODUCT_MESSAGE_1')}
            <span className='hidden md:inline'>
              &nbsp;{t('SOLD_PRODUCT_MESSAGE_2')}
            </span>
          </p>
        </div>
      </div>
      <div className='flex w-full flex-col items-center md:p-4 '>
        <div className='hidden gap-6 md:grid md:grid-cols-3'>
          {products &&
            products.slice(0, 3).map((item, index) => (
              <div className='bg-white' key={index}>
                <ProductListItem key={index} p={item} />
              </div>
            ))}
        </div>
        <div className='mb-1 flex flex-row gap-4'>
          <a href={'/products?machine-types=' + machineTypeLink}>
            <div className='mb-4 cursor-pointer rounded-full bg-white p-2 font-extralight text-black hover:bg-slate-600 hover:text-white md:mb-0 md:mt-4 md:px-10 md:py-4'>
              <p className='hidden md:block'>
                {t('BUTTON_PRODUCT_SOLD_CTA_LONG')}
              </p>
              <p className='m-1 mx-2 block md:hidden'>
                {t('BUTTON_PRODUCT_SOLD_CTA_SHORT')}
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
